import React, { Component } from 'react';


export default class Intro extends Component {

	constructor(props) {
		super(props);
		this.state = { selectedTool: null };

		this.onStartClick = this.onStartClick.bind(this);
	}

	onStartClick() {
		const { FB } = window;

		if (process.env.NODE_ENV === 'development') {
			localStorage.loggedUser = '{"id":"4","name":"Mark Zuckerberg","email":"zuckerber@facebook.com"}';
			location.href = '#/tutorial'; 
			return;
		}

		FB.login(function(response) {
			if (response.authResponse) {
				FB.api('/me?fields=id,name,email', function(response) {
					localStorage.loggedUser = JSON.stringify(response);
					location.href = '#/tutorial'; 
				});
			} else {
				console.log('User cancelled login or did not fully authorize.');
			}
		}, {scope:'email'});
		
	}

	render() {
		return (
			<section className="intro">
				<div className="container">
					
						<div className="display-t"><div className="display-tc">
							<div className="content">
								<a href="#" className="logo-landrover"><img src="img/logo-landrover.png" alt="Land Rover"  width="85"/></a>
								<div className="logo-app">								
									<img src="img/aventura-increible-lg.png" alt="Aventura Increible" className="img-responsive"/>
								</div>

								<p style={{color:'white'}}>Los niños ya han hecho su parte.  <strong>Ahora te toca a ti.</strong>.</p>
								<div className="btn-holder">
									<a className="btn btn-gradientYellow" href="./#/tab">Participar</a>
									{/*<a className="btn btn-gradientYellow" onClick={this.onStartClick}>Comenzar</a>*/}
								</div>
							</div>
						</div></div>
					
				</div>
			</section>
			
		);
	}
}



// WEBPACK FOOTER //
// ./src/Intro.js